export default __webpack_public_path__ + "static/media/modelEmptyState.e34a87ff.svg";